module.exports = __webpack_public_path__ + "img/partner3.f52acf07.png";